import React, { useState } from 'react';

import { useDispatch } from 'react-redux';
import { openSnackbar } from 'store/application';
import Completed from './Completed';
import DailySurveySkeleton from './DailySurveySkeleton';
import FormIO from './FormIO';
import Start from './Start';
import { DailySurveyWrapper, Title } from './styles';
import useDailySurvey from 'hooks/useDailySurvey';

const DailySurveyCore = () => {
  const dispatch = useDispatch();
  const [started, setStarted] = useState(false);

  const {
    completed,
    form = {},
    isTaskDetailsLoading,
    isDailySurveyLoading,
    handleSubmit,
    refetchDailySurvey,
  } = useDailySurvey({
    onSubmit : () => {
      refetchDailySurvey();
      dispatch(
        openSnackbar({
          type    : 'success',
          message : 'Daily survey answers submitted',
        })
      );
      setStarted(false);
    },
    onSubmitError : () =>
      dispatch(
        openSnackbar({
          type    : 'error',
          message : 'Could not save your daily survey answers. Please try again',
        })
      ),
  });

  const handleStart = () => setStarted(true);

  const handleCancel = () => setStarted(false);
  const isLoading = isTaskDetailsLoading || isDailySurveyLoading;

  if (completed) return <Completed />;
  if (isLoading) return <DailySurveySkeleton />;
  if (!started) return <Start
    onStart={handleStart}
  />;
  return <FormIO
    form={form} onSubmit={handleSubmit} onCancel={handleCancel}
  />;
};

export const DailySurvey = () => {
  return (
    <DailySurveyWrapper>
      <Title
        variant='h6'>Daily survey</Title>
      <DailySurveyCore />
    </DailySurveyWrapper>
  );
};
